// Decorative card colors for the home bento. (The weekly charts read real
// daily candles via lib/catalog-server.ts; «خواندنی‌ها» reads CMS posts.)

// Decorative card colors (tint/ink pairs in packages/ui globals.css).
export const TONES = ["yellow", "blue", "green", "red", "teal", "violet", "orange", "pink"] as const;
export type Tone = (typeof TONES)[number];

/** TONES in a random order. Call on the server and pass down as props, so the
 *  server HTML and the client agree (no hydration mismatch). Drawing in order
 *  from one shuffle keeps every card on the page a different color. */
export function shuffledTones(): Tone[] {
  const tones: Tone[] = [...TONES];
  for (let i = tones.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [tones[i], tones[j]] = [tones[j]!, tones[i]!];
  }
  return tones;
}
